import { Pipe, PipeTransform } from '@angular/core';
import { CandidatStatusOnMission } from '../utils/enums';

@Pipe({
  name: 'statusMission',
})
export class StatusMissionPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    switch (value) {
      case CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION:
        return 'Appliqué';
      case CandidatStatusOnMission.ACCEPTED:
        return 'Acceptée';
      case CandidatStatusOnMission.REJECTED:
        return 'Rejeté';
      case CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH:
        return 'Signé';
      case CandidatStatusOnMission.PAYMENT_DONE:
        return 'Payé';
      case CandidatStatusOnMission.PENDING:
        return 'Publiée en attente';
      case CandidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT:
        return 'En attente de payement';
      case CandidatStatusOnMission.ARCHIVED:
        return 'Archivé';
      case CandidatStatusOnMission.NEUTRAL:
        return 'Publiée en attente';
      case CandidatStatusOnMission.RESERVED:
        return 'Réservé';
      case CandidatStatusOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT:
        return 'Rejeté';
      default:
        return 'Publiée en attente';
    }
  }
}
